import { ApiClientException } from '../utils/apiClient';

/**
 * Explains why saving an edit of a shared questionnaire or therapy material failed. The backend
 * answers 412 when someone else saved in the meantime and 409 when the item was archived.
 */
export const getQuestionnaireSaveErrorMessage = (
    error: unknown,
    t: (key: string) => string,
    fallback: string,
): string => {
    if (error instanceof ApiClientException) {
        if (error.status === 412) {
            return t('Someone else changed this in the meantime. Reload it and apply your changes again.');
        }
        if (error.status === 409) {
            return t('This was deleted in the meantime and can no longer be edited.');
        }
        if (error.status === 403) {
            return t('You are not allowed to edit this.');
        }
    }

    return error instanceof Error ? error.message : fallback;
};
